export const BYTES_PER_GB = 1024 ** 3;
export const BYTES_PER_MB = 1024 ** 2;

/**
 * Format bytes as human-readable text.
 *
 * @param {number} bytes
 * @param {boolean} si True for SI (1000), false for binary (1024)
 * @param {number} dp Decimal places
 */
export const humanFileSize = (bytes, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return `${bytes} B`;
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;
  let size = bytes;

  do {
    size /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(size) * r) / r >= thresh &&
    u < units.length - 1
  );

  return `${size.toFixed(dp)} ${units[u]}`;
};

/** Legacy plans stored disk_space in GB; newer records use bytes. */
export const normalizeDiskSpaceBytes = value => {
  if (value == null || value === "") {
    return null;
  }

  const n = Number(value);
  if (Number.isNaN(n)) {
    return null;
  }

  if (n > 0 && n < 1_000_000) {
    return n * BYTES_PER_GB;
  }

  return n;
};

export const formatPlanStorageLimit = bytes => {
  const normalized = normalizeDiskSpaceBytes(bytes);
  if (normalized == null) {
    return "Unlimited";
  }

  return humanFileSize(normalized, false, 1)
    .replace(/ TiB$/, " TB")
    .replace(/ GiB$/, " GB")
    .replace(/ MiB$/, " MB");
};

export const gbToBytes = gb => {
  if (gb == null || gb === "") {
    return null;
  }

  const n = Number(gb);
  if (Number.isNaN(n)) {
    return null;
  }

  return n * BYTES_PER_GB;
};

export const bytesToGb = bytes => {
  const normalized = normalizeDiskSpaceBytes(bytes);
  if (normalized == null) {
    return "";
  }

  return normalized / BYTES_PER_GB;
};

/** Legacy plans stored file_size_limit in MB; newer records use bytes. */
export const normalizeFileSizeLimitBytes = value => {
  if (value == null || value === "") {
    return null;
  }

  const n = Number(value);
  if (Number.isNaN(n)) {
    return null;
  }

  if (n > 0 && n < 1_000_000) {
    return n * BYTES_PER_MB;
  }

  return n;
};

export const formatPlanFileSizeLimit = bytes => {
  const normalized = normalizeFileSizeLimitBytes(bytes);
  if (normalized == null) {
    return "--";
  }

  return humanFileSize(normalized, false, 1)
    .replace(/ GiB$/, " GB")
    .replace(/ MiB$/, " MB")
    .replace(/ KiB$/, " KB");
};

export const mbToBytes = mb => {
  if (mb == null || mb === "") {
    return null;
  }

  const n = Number(mb);
  if (Number.isNaN(n)) {
    return null;
  }

  return n * BYTES_PER_MB;
};

export const bytesToMb = bytes => {
  const normalized = normalizeFileSizeLimitBytes(bytes);
  if (normalized == null) {
    return "";
  }

  return normalized / BYTES_PER_MB;
};
